import {
  Field,
  Form, Formik,
} from 'formik';
import React from 'react';
import * as Yup from 'yup';

import { ButtonBase } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import LibraryAddCheckRoundedIcon from '@material-ui/icons/LibraryAddCheckRounded';

import ActionModal from 'components/ActionModal/ActionModal';

import { formatCents } from 'utils/lib';

const useStyles = makeStyles((theme) => ({
  cancelButton: {
    backgroundColor: `${theme.palette.grayScale6.main} !important`,
  },
}));

const CampaignCancelModal = ({
  campaign, cancellationFee, onConfirm, onClose,
}) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <Formik
      initialValues={{
        waiveCancellationFee: cancellationFee === 0, // Set to false by default if there is a cancellation fee > 0
      }}
      onSubmit={async ({ waiveCancellationFee }) => onConfirm(waiveCancellationFee)}
      validationSchema={Yup.object().shape({
        waiveCancellationFee: Yup.boolean().required(),
      })}
    >
      {(props) => {
        const {
          isValid, handleSubmit, isSubmitting, setFieldValue, values,
        } = props;

        return (
          <Form>
            <ActionModal
              backgroundColor={theme.palette.offWhite.main}
              textColor={theme.palette.darkGray.main}
              icon={<LibraryAddCheckRoundedIcon />}
              onClose={onClose}
              title="Are You Sure?"
              message={(
                <>
                  <h5 style={{ fontWeight: 400 }}>
                    {'Are you sure you want to cancel '}
                    <strong>{`${campaign.agent.firstName} ${campaign.agent.lastName}`}</strong>
                    {`'s ${campaign.eventType.name} campaign? No more touches will go out for this campaign once it is cancelled.`}
                    <br />
                    <br />
                    <strong>
                      {cancellationFee > 0
                        ? !values.waiveCancellationFee
                          ? `The agent will have to pay a ${formatCents(cancellationFee)} cancellation fee.`
                          : 'The agent will NOT pay a cancellation fee.'
                        : 'There is no cancellation fee.'}
                    </strong>
                  </h5>
                  {cancellationFee > 0 && (
                    <>
                      <br />
                      <Field
                        name="waiveCancellationFee"
                      >
                        {({ field }) => (
                          <>
                            <Checkbox
                              checked={field.value}
                              tabIndex={-1}
                              onClick={() => setFieldValue(field.name, !field.value, true)}
                              style={{ marginRight: '10px' }}
                            />
                            Waive Cancellation Fee
                          </>
                        )}
                      </Field>
                    </>
                  )}
                </>
                )}
              buttons={[
                <ButtonBase onClick={onClose} className={classes.cancelButton}>No</ButtonBase>,
                <ButtonBase
                  onClick={handleSubmit}
                  disabled={!isValid || isSubmitting}
                >
                  Yes
                </ButtonBase>,
              ]}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default CampaignCancelModal;
